import {
  PRODUCT_DETAIL_FAIL,
  PRODUCT_DETAIL_REQUEST,
  PRODUCT_DETAIL_SUCCESS,
  PRODUCT_LIST_FAIL,
  PRODUCT_LIST_REQUEST,
  PRODUCT_LIST_SUCCESS,
} from "../constant/productConstant";
import { createSlice } from '@reduxjs/toolkit';


const initialState = {
  product: null,
  images: [],
  mainImageIndex: 0,
  isLoupeActive: false,

};

export const productListReducer = (
  state = { loading: true, products: [] },
  action
) => {
  switch (action.type) {
    case PRODUCT_LIST_REQUEST:
      return {
        loading: true,
      };
    case PRODUCT_LIST_SUCCESS:
      return {
        loading: false,
        products: action.payload,
      };
    case PRODUCT_LIST_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const productDetailReducer = (
  state = { product: {}, loading: true },
  action
) => {
  switch (action.type) {
    case PRODUCT_DETAIL_REQUEST:
      return {
        loading: true,
        product: {},
      };

    case PRODUCT_DETAIL_SUCCESS:
    case PRODUCT_LIST_SUCCESS:
      return {
        loading: false,
        product: action.payload,
      };

    case PRODUCT_DETAIL_FAIL:
    case PRODUCT_LIST_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

const productSlice = createSlice({
  name: 'product',
  initialState,
  reducers: {
    setProduct: (state, action) => {
      state.product = action.payload;
    },
    setImages: (state, action) => {
      state.images = action.payload;
    },
    setMainImageIndex: (state, action) => {
      state.mainImageIndex = action.payload;
    },
    setLoupeActive: (state, action) => {
      state.isLoupeActive = action.payload;
    },

  },
});

export const { setProduct, setImages, setMainImageIndex, setLoupeActive } = productSlice.actions;
export default productSlice.reducer;